export const GET_EXPENSES = "GET_EXPENSES";
export const GET_EXPENSES_SUCCESS = "GET_EXPENSES_SUCCESS";
export const GET_EXPENSES_FAILURE = "GET_EXPENSES_FAILURE";

export const CREATE_EXPENSE = "CREATE_EXPENSE";
export const CREATE_EXPENSE_SUCCESS = "CREATE_EXPENSE_SUCCESS";
export const CREATE_EXPENSE_FAILURE = "CREATE_EXPENSE_FAILURE";

export const UPDATE_EXPENSE = "UPDATE_EXPENSE";
export const UPDATE_EXPENSE_SUCCESS = "UPDATE_EXPENSE_SUCCESS";
export const UPDATE_EXPENSE_FAILURE = "UPDATE_EXPENSE_FAILURE";

export const DELETE_EXPENSE = "DELETE_EXPENSE";
export const DELETE_EXPENSE_SUCCESS = "DELETE_EXPENSE_SUCCESS";
export const DELETE_EXPENSE_FAILURE = "DELETE_EXPENSE_FAILURE";

export const SETTLE_EXPENSE = "SETTLE_EXPENSE";
export const SETTLE_EXPENSE_SUCCESS = "SETTLE_EXPENSE_SUCCESS";
export const SETTLE_EXPENSE_FAILURE = "SETTLE_EXPENSE_FAILURE";

export const REJECT_EXPENSE = "REJECT_EXPENSE";
export const REJECT_EXPENSE_SUCCESS = "REJECT_EXPENSE_SUCCESS";
export const REJECT_EXPENSE_FAILURE = "REJECT_EXPENSE_FAILURE";
